const FullWidthThinFeedIcon = ({ ...props }) => {
  return (
    <svg
      width="35"
      height="38"
      viewBox="0 0 35 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.5" width="16" height="14" fill="#A8A8BB" />
      <rect x="0.5" y="16" width="34" height="6" fill="#FB3973" />
      <rect x="0.5" y="24" width="16" height="14" fill="#A8A8BB" />
      <rect x="18.5" width="16" height="14" fill="#A8A8BB" />
      <rect x="18.5" y="24" width="16" height="14" fill="#A8A8BB" />
    </svg>
  );
};

export default FullWidthThinFeedIcon;
